<template>
    <v-dialog
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
        width="800px"
    >
        <v-card>
            <v-card-title>
                <span class="mb-2 text-typography1 text-display-medium">
                    Share via link
                </span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-text-field
                        :value="fullurl()"
                        @focus="clickCopy($event)"
                        class="share-input"
                        label="URL"
                        :hint="message"
                        persistent-hint
                        variant="underlined"
                        readonly
                    >
                        <template v-slot:append>
                            <v-btn
                                id="calc-btn"
                                color="black"
                                icon
                                @click.stop="copyToClipboard(fullurl())"
                            >
                                <v-icon color="secondary"
                                    >mdi-content-copy</v-icon
                                >
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="secondary"
                    variant="text"
                    @click="emit('update:modelValue', false)"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps(['record', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const message = ref('')

async function clickCopy($event) {
    $event.target.select()
    await copyToClipboard(fullurl())
}

function fullurl() {
    if (props.record.calc.persistentCalcID) {
        const calc = props.record.calc
        return `${window.location.origin}/persistentCalcs/${
            calc.persistentCalcID
        }/${calc.major}/${calc.minor}/${calc.patch}?${getParams()}`
    } else {
        return `${window.location.origin}/calcs/${
            props.record.calcId
        }?${getParams()}`
    }
}

function getParams() {
    let string = ''
    for (let param in props.record.body) {
        let val = props.record.body[param]
        if (Array.isArray(val) || val === Object(val)) val = JSON.stringify(val)
        let valUrl = encodeURIComponent(val)
        string += `${param}=${valUrl}&`
    }
    return string.substring(0, string.length - 1)
}

async function copyToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    await navigator.clipboard.writeText(text)
    message.value = 'Copied!'
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
    }
    document.body.removeChild(textArea)
    emit('update:modelValue', false)
}
</script>

<style scoped>
.share-input i--click::after {
    animation: anim-effect-boris 0.3s forwards;
    background-color: red;
}
@keyframes anim-effect-boris {
    0% {
        transform: scale3d(0.3, 0.3, 1);
    }
    25%,
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: scale3d(1.2, 1.2, 1);
    }
}
</style>
